import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { PageSegmentPageLoadMetricsOptions } from '../types';
import { MetricState } from './base-metric';
import { Metric } from './metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
export var PageSegmentLoadMetric = /*#__PURE__*/function (_Metric) {
  _inherits(PageSegmentLoadMetric, _Metric);
  var _super = _createSuper(PageSegmentLoadMetric);
  function PageSegmentLoadMetric(config) {
    var _this;
    _classCallCheck(this, PageSegmentLoadMetric);
    _this = _super.call(this, config);
    _defineProperty(_assertThisInitialized(_this), "isInitial", true);
    _this.config = config;
    return _this;
  }
  _createClass(PageSegmentLoadMetric, [{
    key: "startFromPageLoad",
    value: function startFromPageLoad() {
      var _pageLoadMetaData$sta;
      var pageLoadMetaData = pageLoadMetaMetric.getData();
      this.start({
        startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
      });
      this.isInitial = pageLoadMetaData.isInitial;
      this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      if (_mark === PageSegmentLoadMetric.FMP) {
        return;
      }
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "mark", this).call(this, PageSegmentLoadMetric.FMP, timestamp);
    }
  }, {
    key: "getPageSegmentLoadData",
    value: function getPageSegmentLoadData() {
      return {
        isInitial: this.isInitial
      };
    }
  }, {
    key: "getData",
    value: function getData() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "getData", this).call(this)), this.getPageSegmentLoadData());
    }
  }, {
    key: "getDataToMerge",
    value: function getDataToMerge() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageSegmentLoadData());
    }
  }, {
    key: "merge",
    value: function merge(mergeData) {
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "merge", this).call(this, mergeData);
      this.isInitial = mergeData.isInitial;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$config$ssr,
        _this2 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pageLoadData = pageLoadMetaMetric.getData();
      if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
        if (!this.marks[PageSegmentLoadMetric.FMP]) {
          var mark = SSRGetDoneMark.getDoneMark();
          if (mark) {
            this.markFMP(mark);
          }
        }
      }
      if (this.config.includePageLoadTimings !== PageSegmentPageLoadMetricsOptions.WAIT_UNTIL_PRESENT || pageLoadData.state === MetricState.FINISHED) {
        return _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "stop", this).call(this, params);
      }
      var now = performance.now();
      if (pageLoadData.state === MetricState.STARTED) {
        pageLoadMetaMetric.onStop(function () {
          _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "stop", _this2).call(_this2, _objectSpread(_objectSpread({}, params), {}, {
            stopTime: params.stopTime || now
          }));
        }, function () {
          _this2.cancel();
        });
      }
      return true;
    }
  }]);
  return PageSegmentLoadMetric;
}(Metric);
_defineProperty(PageSegmentLoadMetric, "FMP", 'fmp');